import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { IAfterGuiAttachedParams } from 'ag-grid-community';
import { HireItem, Product } from '../../models';
import { BookingItemNamePipe } from '../pipes/booking-item-name.pipe';
import { LocationNameFromIdPipe } from '../pipes/location-name-from-id.pipe';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
  selector: 'booking-location-cell',
  template: `
    <span *ngIf="params && params.value > 0"
      >Customer collecting ({{
        params.value | locationNameFromId | async
      }})</span
    >
    <span *ngIf="params && !params.value">Delivery</span>
  `,
  providers: [],
  standalone: true,
  imports: [NgIf, AsyncPipe, LocationNameFromIdPipe]
})
export class BookingLocationCellComponent implements AgRendererComponent {
  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {}
}
